import {BackendImageModel,
        BackendImageJSON,
        BackendImageFactory} from './models'
//
//basic definition of how user preferences
//are defined
//on flow screens
//
//
export interface BaseJSON {
  Id_sys: number,
  Uuid_sys: string
}

export class BaseModel {
  Id_sys: number;
  Uuid_sys: string;

  constructor(
    Id_sys: number,
    Uuid_sys: string
  ) {

    this.Id_sys = Id_sys;
    this.Uuid_sys = Uuid_sys

  }
}

export class BaseFactory {

  fromJSON(json: BaseJSON): BaseModel {
    return new BaseModel(
      json.Id_sys,
      json.Uuid_sys
    );
  }

  toJSON(model: BaseModel): BaseJSON {
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys
    }
  }
}


/**********************************************/
/**********************************************/
/**********************************************/


export interface UserProfileJSON extends BaseJSON{
  First_Name_c: string;
  Last_Name_c: string
  Full_Name_c: string;
  Username_c: string;
  Useralias_c: string;
  Phone_c: string;
  Email_c: string;
  Address_Street_c: string;
  Address_Zip_Code_c: string;
  Address_City_c: string;
  Last_Login_c: string;
  initials: string;
  Avatar_c: BackendImageJSON | null;
}

export class UserProfileModel extends BaseModel {
  First_Name_c: string;
  Last_Name_c: string
  Full_Name_c: string;
  Username_c: string;
  Useralias_c: string;
  Phone_c: string;
  Email_c: string;
  Address_Street_c: string;
  Address_Zip_Code_c: string;
  Address_City_c: string;
  Last_Login_c: string;
  initials: string;
  Avatar_c: BackendImageModel | null;

  constructor(
    Id_sys: number,
    Uuid_sys: string,
    First_Name_c: string,
    Last_Name_c: string,
    Full_Name_c: string,
    Username_c: string,
    Useralias_c: string,
    Phone_c: string,
    Email_c: string,
    Address_Street_c: string,
    Address_Zip_Code_c: string,
    Address_City_c: string,
    Last_Login_c: string,
    initials: string,
    Avatar_c: BackendImageModel | null,
  ) {
    super(Id_sys,
          Uuid_sys);
    this.First_Name_c=First_Name_c
    this.Last_Name_c=Last_Name_c
    this.Full_Name_c=Full_Name_c
    this.Username_c=Username_c
    this.Useralias_c=Useralias_c
    this.Phone_c=Phone_c
    this.Email_c=Email_c
    this.Address_Street_c=Address_Street_c
    this.Address_Zip_Code_c=Address_Zip_Code_c
    this.Address_City_c=Address_City_c
    this.Last_Login_c=Last_Login_c
    this.initials=initials
    this.Avatar_c=Avatar_c
  }
}

export class UserProfileFactory {
  fromJSON(json: UserProfileJSON): UserProfileModel {
    let thisAvatar = null;
    if(json.Avatar_c) thisAvatar = new BackendImageFactory().fromJSON(json.Avatar_c)
    return new UserProfileModel(
      json.Id_sys,
      json.Uuid_sys,
      json.First_Name_c,
      json.Last_Name_c,
      json.Full_Name_c,
      json.Username_c,
      json.Useralias_c,
      json.Phone_c,
      json.Email_c,
      json.Address_Street_c,
      json.Address_Zip_Code_c,
      json.Address_City_c,
      json.Last_Login_c,
      json.initials,
      thisAvatar
    )
  }
  toJSON(model: UserProfileModel): UserProfileJSON {
    let thisAvatar = null;
    if(model.Avatar_c) thisAvatar = new BackendImageFactory().toJSON(model.Avatar_c)
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      First_Name_c: model.First_Name_c,
      Last_Name_c: model.Last_Name_c,
      Full_Name_c: model.Full_Name_c,
      Username_c: model.Username_c,
      Useralias_c: model.Useralias_c,
      Phone_c: model.Phone_c,
      Email_c: model.Email_c,
      Address_Street_c: model.Address_Street_c,
      Address_Zip_Code_c: model.Address_Zip_Code_c,
      Address_City_c: model.Address_City_c,
      Last_Login_c: model.Last_Login_c,
      initials: model.initials,
      Avatar_c: thisAvatar
    }
  }
}


/**********************************************/
/**********************************************/
/**********************************************/

export type SortDirectionType = 'asc' | 'desc'

export interface SortOrderJSON {
  rank: number;
  sort_direction: SortDirectionType;
  sort_column_uuid: string;
  field_api_name: string;
}

export class SortOrderModel {
  rank: number;
  sortDirection: SortDirectionType;
  sortColumnUuid: string;
  fieldApiName: string;

  constructor(
    rank: number,
    sortDirection: SortDirectionType,
    sortColumnUuid: string,
    fieldApiName: string
  ) {

    this.rank = rank;
    this.sortDirection = sortDirection;
    this.sortColumnUuid = sortColumnUuid;
    this.fieldApiName = fieldApiName;
  }
}

export class SortOrderFactory {
  fromJSON(json: SortOrderJSON): SortOrderModel {
    return new SortOrderModel(
      json.rank,
      json.sort_direction,
      json.sort_column_uuid,
      json.field_api_name
    )
  }
  toJSON(model: SortOrderModel): SortOrderJSON {
    return {
      rank: model.rank,
      sort_direction: model.sortDirection,
      sort_column_uuid: model.sortColumnUuid,
      field_api_name: model.fieldApiName
    }
  }
  deepcopy(model: SortOrderModel): SortOrderModel {
    return new SortOrderModel(
      model.rank,
      model.sortDirection,
      model.sortColumnUuid,
      model.fieldApiName
    )
  }
  init(): SortOrderModel {
    return new SortOrderModel(1,'asc', '', '')
  }
}
/**********************************************/
/**********************************************/
/**********************************************/

export interface BarChartUIPreferenceJSON {
  Rank_sys: number;
  Width_sys: string;
  HexColour_sys: string;
  group_column_uuid: string;
}

export class BarChartUIPreferenceModel {
  Rank_sys: number;
  Width_sys: string;
  HexColour_sys: string;
  groupColumnUuid: string;

  constructor(
    Rank_sys: number,
    Width_sys: string,
    HexColour_sys: string,
    groupColumnUuid: string
  ) {

    this.Rank_sys = Rank_sys;
    this.Width_sys = Width_sys;
    this.HexColour_sys = HexColour_sys;
    this.groupColumnUuid = groupColumnUuid;
  }
}

export class BarChartUIPreferenceFactory {
  fromJSON(json: BarChartUIPreferenceJSON): BarChartUIPreferenceModel {
    return new BarChartUIPreferenceModel(
      json.Rank_sys,
      json.Width_sys,
      json.HexColour_sys,
      json.group_column_uuid
    )
  }
  toJSON(model: BarChartUIPreferenceModel): BarChartUIPreferenceJSON {
    return {
      Rank_sys: model.Rank_sys,
      Width_sys: model.Width_sys,
      HexColour_sys: model.HexColour_sys,
      group_column_uuid: model.groupColumnUuid
    }
  }
  deepcopy(model: BarChartUIPreferenceModel): BarChartUIPreferenceModel {
    return new BarChartUIPreferenceModel(
      model.Rank_sys,
      model.Width_sys,
      model.HexColour_sys,
      model.groupColumnUuid
    )
  }
}

/*************************************/
/*************************************/
/*************************************/

export interface ListViewUIPreferenceJSON extends BaseJSON {
  Rank_sys: number,
  DisplayType_sys: string,
  IsPinned_sys: boolean
  sort_columns: SortOrderJSON[]
  barchart_groups: BarChartUIPreferenceJSON[]
}

export class ListViewUIPreferenceModel extends BaseModel {

  Rank_sys: number;
  DisplayType_sys: string;
  IsPinned_sys: boolean;
  sortColumns: SortOrderModel[];
  barChartGroups: BarChartUIPreferenceModel[];

  constructor(
    Id_sys: number,
    Uuid_sys: string,
    Rank_sys: number,
    DisplayType_sys: string,
    IsPinned_sys: boolean,
    sortColumns: SortOrderModel[],
    barChartGroups: BarChartUIPreferenceModel[]
  ) {
    super(Id_sys,
          Uuid_sys);

    this.Rank_sys = Rank_sys;
    this.DisplayType_sys = DisplayType_sys;
    this.IsPinned_sys = IsPinned_sys;
    this.sortColumns = sortColumns;
    this.barChartGroups = barChartGroups;
  }
  clone(): ListViewUIPreferenceModel {
    return new ListViewUIPreferenceModel(
      this.Id_sys,
      this.Uuid_sys,
      this.Rank_sys,
      this.DisplayType_sys,
      this.IsPinned_sys,
      this.sortColumns,
      this.barChartGroups
    )
  }
}

export class ListViewUIPreferenceFactory {

  fromJSON(json: ListViewUIPreferenceJSON): ListViewUIPreferenceModel {
    const sortFactory = new SortOrderFactory()
    const barChartFactory = new BarChartUIPreferenceFactory()
    const sortColumns = json.sort_columns.map((thisJson) => sortFactory.fromJSON(thisJson))
    const barChartGroups = json.barchart_groups.map((thisJson) => barChartFactory.fromJSON(thisJson))

    return new ListViewUIPreferenceModel(
      json.Id_sys,
      json.Uuid_sys,
      json.Rank_sys,
      json.DisplayType_sys,
      json.IsPinned_sys,
      sortColumns,
      barChartGroups
    );
  }

  toJSON(model: ListViewUIPreferenceModel): ListViewUIPreferenceJSON {
    const sortFactory = new SortOrderFactory()
    const barChartFactory = new BarChartUIPreferenceFactory()
    const sortColumns = model.sortColumns.map((thisModel) => sortFactory.toJSON(thisModel))
    const barChartGroups = model.barChartGroups.map((thisModel) => barChartFactory.toJSON(thisModel))

    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      Rank_sys: model.Rank_sys,
      DisplayType_sys: model.DisplayType_sys,
      IsPinned_sys: model.IsPinned_sys,
      sort_columns: sortColumns,
      barchart_groups: barChartGroups
    };
  }

  deepCopy(model: ListViewUIPreferenceModel): ListViewUIPreferenceModel {
    const sortFactory = new SortOrderFactory()
    const barChartFactory = new BarChartUIPreferenceFactory()
    const sortColumns = model.sortColumns.map((thisModel) => sortFactory.deepcopy(thisModel))
    const barChartGroups = model.barChartGroups.map((thisModel) => barChartFactory.deepcopy(thisModel))

    return new ListViewUIPreferenceModel(
      model.Id_sys,
      model.Uuid_sys,
      model.Rank_sys,
      model.DisplayType_sys,
      model.IsPinned_sys,
      sortColumns,
      barChartGroups
    );
  }
}

/*************************************/
/*************************************/
/*************************************/

export interface ApplicationUIPreferenceJSON extends BaseJSON {
  Rank_sys: number,
  IsPinned_sys: boolean
}

export class ApplicationUIPreferenceModel extends BaseModel {

  Rank_sys: number;
  IsPinned_sys: boolean;

  constructor(
    Id_sys: number,
    Uuid_sys: string,
    Rank_sys: number,
    IsPinned_sys: boolean
  ) {
    super(Id_sys,
          Uuid_sys);

    this.Rank_sys = Rank_sys;
    this.IsPinned_sys = IsPinned_sys;
  }
  clone(): ApplicationUIPreferenceModel {
    return new ApplicationUIPreferenceModel(
      this.Id_sys,
      this.Uuid_sys,
      this.Rank_sys,
      this.IsPinned_sys
    )
  }
}

export class ApplicationUIPreferenceFactory {

  fromJSON(json: ApplicationUIPreferenceJSON): ApplicationUIPreferenceModel {
    return new ApplicationUIPreferenceModel(
      json.Id_sys,
      json.Uuid_sys,
      json.Rank_sys,
      json.IsPinned_sys
    );
  }

  toJSON(model: ApplicationUIPreferenceModel): ApplicationUIPreferenceJSON {
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      Rank_sys: model.Rank_sys,
      IsPinned_sys: model.IsPinned_sys
    };
  }

  deepCopy(model: ApplicationUIPreferenceModel): ApplicationUIPreferenceModel {
    return new ApplicationUIPreferenceModel(
      model.Id_sys,
      model.Uuid_sys,
      model.Rank_sys,
      model.IsPinned_sys
    );
  }
}

/*************************************/
/*************************************/
/*************************************/

export interface TabUIPreferenceJSON extends BaseJSON {
  Rank_sys: number,
  IsPinned_sys: boolean
}

export class TabUIPreferenceModel extends BaseModel {

  Rank_sys: number;
  IsPinned_sys: boolean;

  constructor(
    Id_sys: number,
    Uuid_sys: string,
    Rank_sys: number,
    IsPinned_sys: boolean
  ) {
    super(Id_sys,
          Uuid_sys);

    this.Rank_sys = Rank_sys;
    this.IsPinned_sys = IsPinned_sys;
  }
  clone(): TabUIPreferenceModel {
    return new TabUIPreferenceModel(
      this.Id_sys,
      this.Uuid_sys,
      this.Rank_sys,
      this.IsPinned_sys
    )
  }
}

export class TabUIPreferenceFactory {

  fromJSON(json: TabUIPreferenceJSON): TabUIPreferenceModel {
    return new TabUIPreferenceModel(
      json.Id_sys,
      json.Uuid_sys,
      json.Rank_sys,
      json.IsPinned_sys
    );
  }

  toJSON(model: TabUIPreferenceModel): TabUIPreferenceJSON {
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      Rank_sys: model.Rank_sys,
      IsPinned_sys: model.IsPinned_sys
    };
  }

  deepCopy(model: TabUIPreferenceModel): TabUIPreferenceModel {
    return new TabUIPreferenceModel(
      model.Id_sys,
      model.Uuid_sys,
      model.Rank_sys,
      model.IsPinned_sys
    );
  }
}

/*************************************/
/*************************************/
/*************************************/

export type PinnedPageType = 'ApplicationPage' | 'ObjectPage' | 'CustomPage'

interface PinnedPageJSON extends BaseJSON {
  ApiName_sys: string,
  Type_sys: PinnedPageType
}
class PinnedPageModel extends BaseModel {
  ApiName_sys: string;
  Type_sys: PinnedPageType;
  constructor (
    Id_sys: number,
    Uuid_sys: string,
    ApiName_sys: string,
    Type_sys: PinnedPageType
  ) {
    super(Id_sys,
          Uuid_sys);
    this.ApiName_sys = ApiName_sys;
    this.Type_sys = Type_sys;
  }
}
export class PinnedPageFactory {
  fromJSON(json: PinnedPageJSON): PinnedPageModel {
    return new PinnedPageModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Type_sys
    );
  }
  toJSON(model: PinnedPageModel): PinnedPageJSON {
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Type_sys: model.Type_sys
    };
  }
}

interface PinnedApplicationJSON extends BaseJSON {
  ApiName_sys: string,
  pinned_page: PinnedPageJSON
}
class PinnedApplicationModel extends BaseModel {
  ApiName_sys: string
  pinnedPage: PinnedPageModel
  constructor (
    Id_sys: number,
    Uuid_sys: string,
    ApiName_sys: string,
    pinnedPage: PinnedPageModel
  ) {
    super(Id_sys,
          Uuid_sys);
    this.ApiName_sys = ApiName_sys;
    this.pinnedPage = pinnedPage;
  }
}
export class PinnedApplicationFactory {
  fromJSON(json: PinnedApplicationJSON): PinnedApplicationModel {
    const pinnedPage = new PinnedPageFactory().fromJSON(json.pinned_page)
    return new PinnedApplicationModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      pinnedPage
    );
  }
  toJSON(model: PinnedApplicationModel): PinnedApplicationJSON {
    const pinned_page = new PinnedPageFactory().toJSON(model.pinnedPage)
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      pinned_page: pinned_page
    };
  }
}

export interface UserUIPreferenceJSON extends BaseJSON {
  pinned_application: PinnedApplicationJSON | null
}

export class UserUIPreferenceModel extends BaseModel {
  pinnedApplication: PinnedApplicationModel | null;
  constructor(
    Id_sys: number,
    Uuid_sys: string,
    pinnedApplication: PinnedApplicationModel | null

  ) {
    super(Id_sys,
          Uuid_sys);
    this.pinnedApplication = pinnedApplication;
  }
}
export class UserUIPreferenceFactory {
  fromJSON(json: UserUIPreferenceJSON): UserUIPreferenceModel {
    let pinnedApplication = null;
    if(json.pinned_application) pinnedApplication = new PinnedApplicationFactory().fromJSON(json.pinned_application)
    return new UserUIPreferenceModel(
      json.Id_sys,
      json.Uuid_sys,
      pinnedApplication
    );
  }
  toJSON(model: UserUIPreferenceModel): UserUIPreferenceJSON {
    let pinned_application = null;
    if(model.pinnedApplication) pinned_application = new PinnedApplicationFactory().toJSON(model.pinnedApplication)
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      pinned_application: pinned_application
    };
  }
}

/**********************************************/
/**********************************************/
/**********************************************/

//DEFINITION OF PIN

export interface PinJSON {
  'object_api_name': string,
  'record_uuid': string,
  'rank': number
}

export class PinModel {
  objectApiName: string;
  recordUuid: string;
  rank: number;

  constructor(
    objectApiName: string,
    recordUuid: string,
    rank: number
  ) {

    this.objectApiName = objectApiName;
    this.recordUuid = recordUuid;
    this.rank = rank;

  }
}

export class PinFactory {

  fromJSON(json: PinJSON): PinModel {
    return new PinModel(
      json.object_api_name,
      json.record_uuid,
      json.rank
    );
  }

  toJSON(model: PinModel): PinJSON {
    return {
      object_api_name: model.objectApiName,
      record_uuid: model.recordUuid,
      rank: model.rank
    }
  }
}
